"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable camelcase */
var combineLearningPanelFreeUrl_1 = __importDefault(require("./combineLearningPanelFreeUrl"));
var rest_1 = __importDefault(require("../../../rest"));
var teamsApi_1 = require("../../mock/teamsApi");
var loginApi_1 = require("../../mock/loginApi");
var TeamAPIs = {
    createTeam: function (body) {
        return rest_1.default.post({
            mockFunc: function () { return ({ json: loginApi_1.successfulResponse }); },
            url: (0, combineLearningPanelFreeUrl_1.default)('/teams/create'),
            body: body,
            returnResponse: true,
        });
    },
    updateTeamName: function (body) {
        return rest_1.default.put({
            mockFunc: function () { return ({ json: loginApi_1.successfulResponse }); },
            url: (0, combineLearningPanelFreeUrl_1.default)('/teams/update'),
            body: body,
            returnResponse: true,
        });
    },
    getUserTeam: function () {
        return rest_1.default.get({
            mockFunc: function () { return teamsApi_1.userTeamData; },
            url: (0, combineLearningPanelFreeUrl_1.default)('/teams/user-team'),
        });
    },
    invitedTeams: function () {
        return rest_1.default.get({
            mockFunc: function () { return console.log('invited teams'); },
            url: (0, combineLearningPanelFreeUrl_1.default)('/teams/invited-teams'),
        });
    },
    inviteUserToTeam: function (body) {
        return rest_1.default.post({
            mockFunc: function () { return loginApi_1.successfulResponse; },
            url: (0, combineLearningPanelFreeUrl_1.default)('/teams/invite-free-user'),
            body: body,
        });
    },
    leaveTeam: function () {
        return rest_1.default.post({
            mockFunc: function () { return loginApi_1.successfulResponse; },
            url: (0, combineLearningPanelFreeUrl_1.default)('/teams/leave'),
        });
    },
    joinTeam: function (body) {
        return rest_1.default.post({
            mockFunc: function () { return ({ json: loginApi_1.successfulResponse }); },
            url: (0, combineLearningPanelFreeUrl_1.default)('/teams/join'),
            body: body,
            returnResponse: true,
        });
    },
    getManagedTeamData: function () {
        return rest_1.default.get({
            mockFunc: function () { return ({ json: teamsApi_1.managedTeamData }); },
            url: (0, combineLearningPanelFreeUrl_1.default)('/teams/managed-team'),
            returnResponse: true,
        });
    },
    getVerifyTeamName: function (teamName) {
        return rest_1.default.get({
            mockFunc: function () { return ({ json: { is_valid: true } }); },
            url: (0, combineLearningPanelFreeUrl_1.default)("/teams/verify-team-name/?team_name=".concat(teamName)),
            returnResponse: true,
        });
    },
    updateTeam: function (teamName, userEmailsToInvite, userEmailsToRemove) {
        return rest_1.default.put({
            mockFunc: function () { return ({ json: loginApi_1.successfulResponse }); },
            url: (0, combineLearningPanelFreeUrl_1.default)('/teams/update'),
            body: {
                team_name: teamName,
                user_emails_to_invite: userEmailsToInvite,
                user_emails_to_remove: userEmailsToRemove,
            },
            returnResponse: true,
        });
    },
};
exports.default = TeamAPIs;
